import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("blogUser");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = (userObj, remember) => {
    setUser(userObj);
    if (remember) {
      localStorage.setItem("blogUser", JSON.stringify(userObj));
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("blogUser");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
